import React from "react";

const FacturaCredito = () => {
    return (
      
       
        <div>hola</div>
       
    )
}
export default FacturaCredito;